export default "__VITE_ASSET__BKv$0sLb__"